import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme, whenHovered } from "../../theme";
import { textStyles } from "../Text";
import { valueToPercent } from "./slider-utils";
import { easeCurves, eases } from "../../motion/eases";
export function MarkIndicator(_ref) {
  var animationVariants = _ref.animationVariants,
      mark = _ref.mark,
      min = _ref.min,
      max = _ref.max;
  var percentage = valueToPercent(mark.value, min, max);

  var _getStyles = getStyles(percentage),
      markStyles = _getStyles.mark;

  return /*#__PURE__*/React.createElement(motion.div, {
    variants: animationVariants
  }, /*#__PURE__*/React.createElement(StyledMarkIndicator, {
    style: markStyles
  }));
}

function getStyles(percentage) {
  return {
    mark: {
      left: "".concat(percentage, "%"),
      transform: 'translateX(-50%)'
    },
    label: {
      left: "".concat(percentage, "%")
    }
  };
}

var StyledMarkIndicator = styled.span.withConfig({
  displayName: "Mark__StyledMarkIndicator",
  componentId: "vapor__oqg3rb-0"
})(["position:absolute;width:2px;height:var(--fio-slider-tracksize);background-color:", ";"], theme.colors.palette.whiteA15);
export function MarkLabel(_ref2) {
  var animationVariants = _ref2.animationVariants,
      mark = _ref2.mark,
      min = _ref2.min,
      max = _ref2.max,
      fade = _ref2.fade,
      _onTapStart = _ref2.onTapStart;
  var percentage = valueToPercent(mark.value, min, max);

  var _getStyles2 = getStyles(percentage),
      labelStyles = _getStyles2.label;

  return /*#__PURE__*/React.createElement(motion.div, {
    key: mark.value,
    variants: animationVariants
  }, mark.label && /*#__PURE__*/React.createElement(StyledMarkLabel, {
    "data-testid": "slider-mark",
    "aria-hidden": true,
    transition: {
      duration: 0.25,
      ease: eases.primary
    },
    animate: {
      opacity: fade ? 0.4 : 1
    },
    initial: {
      opacity: 1
    },
    whileHover: {
      opacity: 1
    },
    onTapStart: function onTapStart(e) {
      e.stopPropagation();

      _onTapStart();
    },
    style: labelStyles
  }, mark.label));
}
var StyledMarkLabel = styled(motion.span).withConfig({
  displayName: "Mark__StyledMarkLabel",
  componentId: "vapor__oqg3rb-1"
})(["", ";transform:translateX(-50%) translateY(-50%);top:50%;white-space:nowrap;color:", ";cursor:pointer;position:absolute;user-select:none;border-radius:", ";padding:", " ", ";transition:color 0.2s ", ",background-color 0.2s ", ";", "{background-color:", ";color:", ";}"], textStyles.secondary, theme.colors.palette.whiteA60, theme.radii[4], theme.spaces[2], theme.spaces[4], easeCurves.primary, easeCurves.primary, whenHovered, theme.colors.palette.tintA15, theme.colors.palette.whiteA90);